import LocalizedStrings from 'react-localization';

const strings = new LocalizedStrings({
    en:{
        errorCreation: "this email is already taken",
        title: 'Register',
        welcomeHeading: 'Creating an account allows you to:',
        reasonDistance: 'Check the state of your batteries from anywhere',
        reasonAlerts: 'Be notified if ever one of your batteries needs your attention',
        reasonHistory: 'Check the history of your batteries',
        nameLabel: 'Name',
        namePlaceholder: 'John Smith',
        emailLabel: 'Email Address',
        emailPlaceholder: 'example@email.com',
        passwordLabel: 'Password',
        passwordPlaceholder: '••••••••••',
        passwordConfirmationLabel: 'Confirm Password',
        passwordConfirmationPlaceholder: '••••••••••',

        loginButton: 'Login',
        registerButton: 'Register',

        submitButton: 'Validate',

        generalError: 'An error has occurred, please check your connection',
        rejectionError: 'A problem has occurred, please check your account information',

        alreadyAccount: 'Do you already have an account?',
    },
    fr:{
        errorCreation: "Cet email est déjà utilisé",
        title: 'Souscription',
        welcomeHeading: 'La création d\'une compte vous permet de :',
        reasonDistance: 'De vérifier l\'état de vos batteries de n\'importe où',
        reasonAlerts: 'D\'être notifié si jamais un de vos batteries a besoin de votre attention',
        reasonHistory: 'De consulter l\'historique de vos batteries',
        nameLabel: 'Nom',
        namePlaceholder: 'Pierre Dupont',
        emailLabel: 'Adresse email',
        emailPlaceholder: 'exaeple@email.fr',
        passwordLabel: 'Mot de passe',
        passwordPlaceholder: '••••••••••',
        passwordConfirmationLabel: 'Confirmation de mot de passe',
        passwordConfirmationPlaceholder: '••••••••••',

        loginButton: 'Connexion',
        registerButton: 'Souscrire',

        submitButton: 'Valider',

        generalError: 'Une erreur est servenue, merci de vérifier votre connexion',
        rejectionError: 'Une problème est servenue, merci de vérifier votre saisie',

        alreadyAccount: 'Vous avez déjà une compte ?'
    }
})

export default strings